const DEV_SERVER = false;
const SERVER_URL = DEV_SERVER?"http://192.168.1.2:3002/":"https://server.tasimacim.com/";

module.exports.fetch = (url, body) => {
    //https://server.tasimacim.com/web/
    //ttp://192.168.1.8:3002
    return new Promise(resolve => {
        
        //
        fetch(SERVER_URL+"web/" + url, {body: JSON.stringify(body), method:"POST", headers: {"Content-Type": "application/json"}}).then((e) => e.json()).then((dat) => resolve(dat)).catch((e) => console.log(e));
    })
    
}

var token;
module.exports.user = undefined;
module.exports.SERVER_URL = SERVER_URL;

module.exports.setLogin = (t, user) => {
    token = t;
    module.exports.user = user;
}

module.exports.fetchClient = (url, body) => {
    //https://server.tasimacim.com/web/
    //http://localhost:3002/
    return new Promise(resolve => {
        
        //
        
        fetch(SERVER_URL + url, {body: JSON.stringify(body), method:"POST", headers: {"Content-Type": "application/json",Authorization: "Bearer " + token}}).then((e) => e.json()).then((dat) => resolve(dat)).catch((e) => console.log(e));
    })
    
}

module.exports.getDescription = (address) => {
    var p = "";

    if(address.building && address.building != "") p += "Bina: " + address.building + " ";
    if(address.floor && address.floor != "") p += "Kat: " + address.floor + " ";
    if(address.door && address.door != "") p += "Daire: " + address.door + " ";

    return p;
}